export { default } from './ItemAutor';
